import { useState } from "react";
import { Checkbox } from "@/components/ui/Field";
import { HtmlTemplateEditor } from "./components/HtmlTemplateEditor";
import {
  getTimesheetTemplate,
  saveTimesheetTemplate,
  getStuecklisteTemplate,
  saveStuecklisteTemplate,
  getProjectCoverTemplate,
  saveProjectCoverTemplate,
  getOrderCoverTemplate,
  saveOrderCoverTemplate,
  resetOrderCoverTemplate,
  getDoorMaintenanceTemplate,
  saveDoorMaintenanceTemplate,
  getDoorIssueTemplate,
  saveDoorIssueTemplate,
  uploadDoorIssueTemplate,
} from "./lib/settingsApi";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { SettingsAccessDenied } from "./SettingsLayout";

export function VorlagenPage() {
  const acl = useSettingsAcl();
  const [onePerBnr, setOnePerBnr] = useState(false);
  const [orderLoaded, setOrderLoaded] = useState(false);

  if (acl.loading) return null;
  if (!acl.canAuftraege && !acl.canBestellungen) return <SettingsAccessDenied />;

  return (
    <div className="space-y-6">
      {acl.canAuftraege && (
        <>
          <HtmlTemplateEditor
            title="Stundennachweis – HTML-Template"
            description="Jinja/HTML-Vorlage für gedruckte Stundennachweise."
            load={getTimesheetTemplate}
            save={saveTimesheetTemplate}
          />
          <HtmlTemplateEditor
            title="Stückliste – HTML-Template"
            description="Jinja/HTML-Vorlage für Stücklisten. QR: {{ qr_data_uri }}, {{ qr_url }}, {{ public_view_url }}. Zusätzlich: {{ werkzeug_positionen }}, {{ notizen }}."
            load={getStuecklisteTemplate}
            save={saveStuecklisteTemplate}
          />
          <HtmlTemplateEditor
            title="Projekt-Deckblatt – HTML-Template"
            description="Deckblatt-Vorlage für Projekt-Aufträge."
            load={getProjectCoverTemplate}
            save={saveProjectCoverTemplate}
          />
          <HtmlTemplateEditor
            title="Türwartung – Wartungsprotokoll-Template"
            load={getDoorMaintenanceTemplate}
            save={saveDoorMaintenanceTemplate}
          />
          <HtmlTemplateEditor
            title="Türwartung – Mängelübersicht-Template (Note 3/5)"
            load={getDoorIssueTemplate}
            save={saveDoorIssueTemplate}
            extraControls={
              <div className="mb-3">
                <label className="eh-label">Word-Vorlage hochladen</label>
                <input
                  type="file"
                  accept=".docx,.doc"
                  className="eh-input mt-1"
                  onChange={async (e) => {
                    const f = e.target.files?.[0];
                    if (f) await uploadDoorIssueTemplate(f);
                    e.target.value = "";
                  }}
                />
              </div>
            }
          />
        </>
      )}
      {acl.canBestellungen && (
        <HtmlTemplateEditor
          title="Bestellung – Deckblatt-Template (Druck)"
          description="Deckblatt für Bestellungen beim Druck."
          load={async () => {
            const data = await getOrderCoverTemplate();
            setOnePerBnr(!!data.one_per_bnr);
            setOrderLoaded(true);
            return data.html;
          }}
          save={async (html: string) => {
            await saveOrderCoverTemplate(html, onePerBnr);
          }}
          onReset={resetOrderCoverTemplate}
          extraControls={
            orderLoaded ? (
              <Checkbox
                label="Ein Deckblatt pro BNR"
                checked={onePerBnr}
                onChange={(e) => setOnePerBnr(e.target.checked)}
                className="mb-3"
              />
            ) : null
          }
        />
      )}
    </div>
  );
}
